<div checkoutCy="mixed-card-offer-{{ plan.gencode }}" class="is-centered pricing-plan is-fullheight">
    <div class="pricing-plan-product is-fullheight">
        <div class="is-3 is-radiusless plan-header no-height has-background-white">
            <checkout-card-offer-header-byou
                [dataEnvelope]="plan.data.data_envelope"
                [catchyDescription]="plan.data.catchy_description"
                [gencode]="plan.gencode"
                [canBeLockedPlan]="plan.data.locked === '1'"
                [isLocked]="isLocked"
                (lockedToggleEvent)="setLocked($event)"
                [connectionSpeed]="plan.data?.max_connection"
                [hasHat]="hasHat"
            />
        </div>
        <div class="plan-items box is-shadowless is-fullheight">
            @if (atLeastOneOfferHasPromoHome) {
                <div class="is-flex is-centered mb-1 promo-sticker">
                    @if (promoHome) {
                        <div class="sticker is-small">{{ promoHomeWording }}</div>
                    }
                </div>
            }
            <checkout-byou-card-pepites [plan]="plan"></checkout-byou-card-pepites>

            <div class="sticker-summer-edition is-flex is-centered">
                @if (isSummerEdition) {
                    <div class="sticker is-small is-blue-byou">Summer edition</div>
                }
            </div>

            <div class="is-3 plan-item prices-block no-height">
                <div class="plan-price no-height has-text-centered">
                    <div class="prices-block">
                        <div class="is-main-price">
                            <checkout-prices-block
                                [displayConnectLink]="false"
                                [subscription]="plan"
                                [quoteIndex]="quoteIndex"
                                [isInlined]="false"
                            />
                        </div>
                    </div>
                    <p class="is-level-3 text is-marginless">{{ plan.data.obligation | obligationLabel }}</p>
                    <br />
                </div>
            </div>
            <div class="ctas is-flex is-vertical has-margin-top-auto">
                @if (showAction) {
                    <div class="is-2 plan-item no-height plan-item-cta has-text-centered">
                        @if (!qty) {
                            <button
                                checkoutCy="add-offer-{{ plan.gencode }}"
                                class="button is-marginless is-fullwidth is-blue-byou"
                                (click)="add()"
                                [ngClass]="{
                                    'is-loading': isLoading,
                                    'is-primary': cartForm.status === 'VALID',
                                    'is-conversion': cartForm.status === 'INVALID',
                                }"
                            >
                                Ajouter ce forfait
                            </button>
                        }
                        @if (qty) {
                            <button
                                class="button is-marginless is-fullwidth is-secondary remove-btn"
                                (click)="remove()"
                                [ngClass]="{ 'has-actions-disabled': isLoading }"
                            >
                                Supprimer
                            </button>
                        }
                    </div>
                }

                <a class="link has-centered mt-2 is-flex is-justified-center" (click)="view()">
                    *&nbsp;Voir les destinations {{ isSummerEdition ? 'Summer edition' : 'en Europe' }}
                </a>
            </div>
        </div>
    </div>
</div>
